var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
import { jsx as _jsx } from "react/jsx-runtime";
import { Cog6ToothIcon, CreditCardIcon, TagIcon, UserIcon } from '@heroicons/react/24/outline';
import Tabs from '@web/components/layout/Tabs';
import { ActivityLabels } from '@web/components/Settings/ActivityLabels/ActivityLabels';
import Billing from '@web/components/Settings/Billing/Billing';
import GeneralSettings from '@web/components/Settings/GeneralSettings';
import Members from '@web/components/Settings/Members/Members';
import { settingsUrl } from '@web/router/urls';
import { useNavigateTo } from '@web/utility/hooks/useNavigateTo';
import { settingsActiveTabs } from '@web/utility/tabs';
import { SettingsTabsEnum } from '@workalizer/shared';
import { useParams } from 'react-router-dom';
var settingsTabsMap = (_a = {},
    _a[SettingsTabsEnum.GENERAL] = {
        name: 'General',
        icon: _jsx(Cog6ToothIcon, {}),
        Component: GeneralSettings
    },
    _a[SettingsTabsEnum.USERS] = {
        name: 'Teams/Users',
        icon: _jsx(UserIcon, {}),
        Component: Members
    },
    _a[SettingsTabsEnum.BILLING] = {
        name: 'Billing',
        icon: _jsx(CreditCardIcon, {}),
        Component: Billing
    },
    _a[SettingsTabsEnum.ACTIVITY_LABELS] = {
        name: 'Activity Labels',
        icon: _jsx(TagIcon, {}),
        Component: ActivityLabels
    },
    _a);
export var Settings = function () {
    var _a = useParams().activeTab, activeTab = _a === void 0 ? settingsActiveTabs.users : _a;
    var navigateTo = useNavigateTo();
    var tabs = Object.values(SettingsTabsEnum).map(function (tabId) { return (__assign({ id: tabId }, settingsTabsMap[tabId])); });
    function onChange(id) {
        navigateTo({ pathname: "".concat(settingsUrl, "/").concat(id) });
    }
    return (_jsx("div", { children: _jsx(Tabs, { active: activeTab, tabs: tabs, onChange: onChange }) }));
};
export default Settings;
